import { Indication } from '../store/markettingContentGeneration/stateSegments/brandsInformationStateSegment';

interface IndicationTransformed {
  id: string;
  name: string;
  label: string;
  shortName: string;
  longName: string;
  inclusions: string;
  exclusions: string;
}

const processIndicationsArray = (
  indicationsArray: Indication[]
): IndicationTransformed[] => {
  return indicationsArray?.map(indication => {
    const processedIndication: IndicationTransformed = {
      ...indication,
      inclusions: Array.isArray(indication?.inclusions)
        ? indication?.inclusions?.join(', ')
        : indication?.inclusions,
      exclusions: Array.isArray(indication?.exclusions)
        ? indication?.exclusions?.join(', ')
        : indication?.exclusions,
    };

    return processedIndication;
  });
};

export default processIndicationsArray;
